import {SELECT_CHANGE_EVENT} from "../constants";

/**
 * @param {string|number} value
 * @param {MouseEvent} mouseEvent
 * @param {Element} src
 */
export function dispatchSelectChangeEvent(value, mouseEvent, src) {
    const event = new CustomEvent(SELECT_CHANGE_EVENT, { bubbles: true, detail: { value, mouseEvent }});
    src.dispatchEvent(event);
}
